/**
 * @generated SignedSource<<535af53561736a2d836fc81ae5b4bf2f>>
 * @relayHash ab315f9ffdcbe8bd8ba7b5de061e5649
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 46b09365c92c616fad0f3bc4329e6d2421389f9a3a81cc6bcfaa80c14a330137

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcIncidentsPageInternalQuery } from './srcIncidentsPageInternalQuery.graphql';

const node: PreloadableConcreteRequest<srcIncidentsPageInternalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "46b09365c92c616fad0f3bc4329e6d2421389f9a3a81cc6bcfaa80c14a330137",
    "metadata": {
      "connection": [
        {
          "count": "servicePageSize",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "jira",
            "jiraProjectByKey",
            "linkedOperationsComponentsByProject"
          ]
        }
      ]
    },
    "name": "srcIncidentsPageInternalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
